import CREApi from './_creApi';
import httpClient from '@/apis/base/httpclient';
class CRERepReportSubmitAPI extends CREApi {
  constructor() {
    super();
  }
  controllerName = 'CRERepReportSubmits';

  /**
   * Check trùng báo cáo nộp lên cấp trên
   * @param {*} payload
   * @returns
   */
  checkDuplicateX1Online(payload) {
    let request = {
      url: this.getAPIUrl() + '/CheckDuplicateX1Online',
      data: payload,
    };

    return httpClient.postAsync(request);
  }
  /**
   * Hàm lưu dữ liệu nộp báo cáo lên cấp trên
   * @param {dữ liệu nộp} data
   */
  saveCREReportSubmit(data) {
    let request = {
      url: this.getAPIUrl() + '/saveCREReportSubmit',
      data: data,
    };
    return httpClient.postAsync(request);
  }

  /**
   *  Check dữ liệu C03CCTT
   * @param {*} year
   * @returns
   */
  checkDataC03CCTT(year) {
    let request = {
      url: this.getAPIUrl() + `/CheckDataC03CCTT/${year}`,
    };

    return httpClient.getAsync(request);
  }
  /**
   * Lấy dữ liệu người đại diện gần nhất
   * ncdinh 07/04/2023
   * @param {*} year
   * @returns
   */
  GetRecentRepresenter(year) {
    let request = {
      url: this.getAPIUrl() + `/GetRecentRepresenter/${year}`,
    };
    return httpClient.getAsync(request);
  }
  /**
   * Cập nhập trạng thái báo cáo theo năm
   * ncdinh 10/04/2023
   * @param {*} payload
   * @param {*} year
   * @returns
   */
  UpdateReportStatus(payload) {
    let request = {
      url: this.getAPIUrl() + `/UpdateReportStatus`,
      data: payload,
    };
    return httpClient.postAsync(request);
  }
}

export default new CRERepReportSubmitAPI();
